import { cn } from '@/lib/utils';

import { getCountForm } from './utils';

interface CountdownTimerProps {
  label?: string;
  timeComponents: {
    days: string;
    mins: string;
    hours: string;
    secs: string;
  };
  isTimerVisible?: boolean;
  size?: 'm' | 'l';
}

export const CountdownTimer = ({
  label,
  timeComponents,
  isTimerVisible = true,
  size = 'l',
}: CountdownTimerProps) => (
  <div>
    <span>
      {!!label && label}
      {isTimerVisible && !!label && <span> -</span>}
    </span>
    {isTimerVisible && (
      <div data-hidden='false' className='flex gap-3'>
        <CountdownTimeComponent
          size={size}
          time={timeComponents.days}
          unit={getCountForm(Number(timeComponents.days), 'DAY', 'DAYS')}
        />
        :
        <CountdownTimeComponent
          size={size}
          time={timeComponents.hours}
          unit={getCountForm(Number(timeComponents.hours), 'HR', 'HRS')}
        />
        :
        <CountdownTimeComponent
          size={size}
          time={timeComponents.mins}
          unit='MIN'
        />
        :
        <CountdownTimeComponent
          size={size}
          time={timeComponents.secs}
          unit='SEC'
        />
      </div>
    )}
  </div>
);

const CountdownTimeComponent = ({
  time,
  unit,
  size,
}: {
  time: string;
  unit: string;
  size?: 'm' | 'l';
}) => {
  return (
    <div className='flex flex-col items-center gap-2'>
      <div
        className={cn(
          size === 'l' ? 'text-subtitle-l' : 'text-body-m font-bold'
        )}
      >
        <span data-hidden='false'>{time}</span>
      </div>
      <small className={cn(size === 'l' ? 'text-body-l' : 'text-label-text-m')}>
        {unit}
      </small>
    </div>
  );
};
